import React, { useEffect } from 'react';

import { AnimatePresence } from 'framer-motion';

import { ReactComponent as AptosSvg } from './icons/aptos.svg';
import { ReactComponent as PolygonSvg } from './icons/polygon.svg';

import { Icon, Text, Wrapper } from './styles';

const CRYPTO_CHAINS = {
    polygon: { name: 'Polygon', icon: <PolygonSvg /> },
    aptos: { name: 'Aptos', icon: <AptosSvg /> },
};

type CryptoChainTypes = keyof typeof CRYPTO_CHAINS;

interface CardChainAnimationProps {
    chain?: CryptoChainTypes;
    show: boolean;
    setShow: (show: boolean) => void;
}

export const CardChainAnimation = ({ chain, show, setShow }: CardChainAnimationProps) => {
    useEffect(() => {
        if (show) {
            const timeoutId = setTimeout(() => {
                setShow(false);
            }, 3000);

            return () => clearTimeout(timeoutId);
        }
    }, [show, setShow]);

    return (
        <AnimatePresence>
            {show && chain ? (
                <Wrapper $chain={chain} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                    <Text>You just added a {CRYPTO_CHAINS[chain].name} asset to your lineup</Text>
                    <Icon>{CRYPTO_CHAINS[chain].icon}</Icon>
                </Wrapper>
            ) : null}
        </AnimatePresence>
    );
};
